import store from '@/Store'

const urlBase = process.env.VUE_APP_CHAT_API
const ChatApi = (API) => {
  return {
    async getAtendente (authorization) {
      const url = `${urlBase}/attendants/me`
      return API.get(url, {
        headers: {
          Authorization: authorization,
          instancia_aplicacao: store.getters['SetupApp/instanciaAplicacao']
        }
      })
    }
  }
}

export default ChatApi
